module.exports = __webpack_public_path__ + "static/media/trademark.2197881e.svg";